import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { useMatches } from 'react-router';
import { z } from 'zod';

// A route supplies a component here, so the handle check confirms the slot holds something callable.
const viewsSchema = z.object({
  Views: z.custom<(props: Record<string, unknown>) => ReactNode>((val) => typeof val === 'function'),
});

/**
 * Render an views for the current route.
 *
 * A route defines its views via its `handle`.
 */
export function Views() {
  const matches = useMatches();

  const RouteViews = useMemo(() => {
    const reversedMatches = [...matches].reverse();

    for (const match of reversedMatches) {
      const parse = viewsSchema.safeParse(match.handle);
      if (parse.success) {
        return parse.data.Views;
      }
    }
    return undefined;
  }, [matches]);

  if (RouteViews === undefined) {
    return null;
  }

  return (
    <div>
      <RouteViews />
    </div>
  );
}
